import React from 'react';

import Quicks from '../components/quicks';
import MarkdownSection from '../components/markdown-section';
import ResearchAndPublications from '../components/research-n-pubs';
import NewsUpdates from '../components/news-updates';
// import Education from '../components/education';
import Projects from '../components/projects';
import ResearchScholars from '../components/research-scholars';
import PGStudents from '../components/pg-students';
// import Teaching from '../components/teaching';
// import ShortTermCourses from '../components/short-term-courses';
import ProfessionalActivities from '../components/professional-activities';

const Component = () => {
    return (
        <div>
            <Quicks
                links={[
                    { name: 'Publications', link: 'publications' },
                    { name: 'Tools & Data', link: 'tools' },
                    { name: 'PLANR Lab', link: 'https://www.iitp.ac.in/~planrlab/' },
                    { name: 'Gallery', link: 'gallery' }
                ]}
                navs={[
                    { name: 'Research & Publications', link: '#ResearchAndPublications' },
                    { name: 'Education, Awards & Honours', link: '#Education' },
                    { name: 'Teaching', link: '#Teaching' },
                    { name: 'Professional Activities', link: '#ProfessionalActivities' }
                ]}
            />

            <div className="row">
                <div className="col-md-4">
                    <NewsUpdates news={[]} />
                </div>
                <div className="col-md-8">
                    <ResearchAndPublications />
                </div>
            </div>
            <p> </p>
            {/* <MarkdownSection
                className="row"
                header="PLANR Lab"
                sectionID="planr-lab"
                mdURL="_data/home/research-n-pub.md"
            /> */}
            <MarkdownSection
                className="row"
                header="Education, Awards & Honours"
                sectionID="Education"
                mdURL="_data/home/education.md"
            />
            {/* <Education /> */}
            <Projects />
            <ResearchScholars />
            <PGStudents />
            <MarkdownSection
                className="row"
                header="Courses Taught/Teaching"
                sectionID="Teaching"
                mdURL="_data/home/teaching.md"
            />
            <MarkdownSection
                className="row"
                header="Short-term Courses Organized"
                sectionID="ShortTermCourses"
                mdURL="_data/home/short-term-courses.md"
            />
            <MarkdownSection
                className="row"
                header="Invited Talk"
                sectionID="InvitedTalk"
                mdURL="_data/home/invited-talk.md"
            />

            <ProfessionalActivities />
        </div>
    );
};

export default Component;
